import { app } from '../../../../../app';
import { Controller } from './add-role.controller';

app.component('companyManageApplicationRolesAdd', {
    bindings: {
        appId: '<',
        companyId: '<',
        roles: '<',
    },
    controller: Controller,
    templateUrl: require('./add-role.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/add/add-role.component.js